<script context="module">
  let focus = null
</script>

<script>
  import { onMount, tick } from 'svelte'
  import { page } from './stores'
  
  export let src
  export let alt = 'Only for measure'
  export let dispx = 50
  export let dispy = 0
  export let zoom = 0
  export let hide = false
  export let nofocus

  let mynode, myimage  // nodes
  let owidth, oheight, width, dwidth
  let x, y, center, offsetx
  let moving = hide
  let initX, initY
  let innerHeight, height
  
  onMount(() => {
    if (!hide) {
      console.log(myimage)
      onResize()
    }
    if (!nofocus) {
      // console.log('focus',mynode)
      mynode.focus()
      focus = mynode
    }
  })
  
  function onResize(e) {    
    if (e) innerHeight = e.target.innerHeight    
    const rect=mynode.getBoundingClientRect()
    height = Math.floor(innerHeight - rect.y * 1.4)  // vyska obdelniku = minimalni vyska obrazku
    onLoad()    
    console.log('resize', mynode, innerHeight, height, rect)
  }

  async function onLoad() {
    if (!height) onResize()
    console.log('tick', mynode.offsetWidth)
    await tick()
    dwidth = mynode.offsetWidth  // sirka obdelniku
    owidth = myimage.naturalWidth  // orginalni sirka obrazku
    oheight = myimage.naturalHeight  // orginalni vyska obrazku
    width = owidth / oheight * height // minimalni sirka obrazku
    x = (owidth-width)/100  // procentualni prirustek sirky obrazku
    y = (oheight-height)/100 // procentualni prirustek vysky obrazku
    console.log('imgload',dwidth,owidth,oheight,width,x,y)
  }

  function onKey(e) {
    if (focus !== mynode) return
    console.log('key', e.key)
    if (e.key == 'ArrowUp' || e.key == 'w') { dispy -= 5; if (dispy < 0) dispy = 0 }
    else if (e.key == 'ArrowDown' || e.key == 's') { dispy += 5; if (dispy > 100) dispy = 100 } 
    else if (e.key == 'ArrowLeft' || e.key == 'a') { dispx -= 5; if (dispx < 0) dispx = 0 }
    else if (e.key == 'ArrowRight' || e.key == 'd') { dispx += 5; if (dispx > 100) dispx = 100 }
    else if (e.key == '+') { zoom += 5; if (zoom > 100) zoom = 100 }
    else if (e.key == '-') { zoom -= 5; if (zoom < 0) zoom = 0 }
  }

  function onMouseUp() {
    console.log('up',moving, mynode.offsetWidth); moving = false
    if (dwidth !== mynode.offsetWidth) { 
      // HACK: kvuli levemu po resize
      console.log('dwidth')
      dwidth = mynode.offsetWidth
    }
  }

  function onWheel(e) {
    moving = false
    const speed = 9000 / owidth
    const dir = e.deltaY < 0 ? speed : -speed
    zoom = +zoom + dir
    if (zoom <0) zoom=0
    else if (zoom>100) zoom = 100
    // console.log('wheel',e.deltaY,zoom, speed)
  }

  function onMove({ clientX, clientY, pageX, pageY, screenX, screenY }) {
    if (!moving) return

    dispx += clientX-initX
    if (dispx > 100) dispx = 100
    else if (dispx < 0) dispx = 0
    
    dispy += clientY-initY
    if (dispy > 100) dispy = 100
    else if (dispy < 0) dispy = 0

    // console.log('move',clientX-initX, clientY-initY)
    initX = clientX
    initY = clientY
  }

  $: awidth = x*zoom+width  // aktualni sirka obrazku
  $: tmpy = y/100*dispy*zoom
  $: if (awidth <= dwidth) { 
      center = 'center'
      offsetx = (dwidth-awidth) / 2  
    } else {
      offsetx = (-x/100*dispx*zoom)+((dwidth-width)/100*dispx)
      center = offsetx + 'px'
  }
  // +(parseInt(center) ? center : 0)
  
</script>
<!-- {hide} {myimage} -->
<!-- {initX} {initY} {y} {zoom} {height} | {dwidth} {owidth} {width} {awidth} | {offsetx}} -->
<div class="containerln">
  <div class="main"
    bind:this={mynode}
    on:wheel|preventDefault={onWheel}
    on:mousemove={onMove}
    on:mousedown={({clientX, clientY}) => {console.log('down',moving, initX, clientX, initY, clientY); moving = true; initX = clientX; initY = clientY, focus = mynode}}
    style:background-image="url({src})" 
    style:background-position="{center} -{tmpy}px"
    style:background-size="{awidth}px {y*zoom+(+height)}px"
    style:height="{height}px"
  > 
    <!-- {#if !moving} -->
      <slot params={{scale: awidth/owidth, offsetx, offsety:-tmpy, moving}} />
    <!-- {/if} -->
  </div>
</div>

{#if !hide}
  <img bind:this={myimage} on:load={onLoad} on:error={(e) => {console.log(e); page.set('list')}} {src} {alt} />
{/if}
<svelte:window bind:innerHeight on:resize={onResize} on:mouseup={onMouseUp} on:keydown={onKey} />

<style>
  .containerln {
    position: relative;
    overflow: hidden;
  }
  .main {
    /*flex-basis: auto;
    background-size: contain;*/
    background-repeat: no-repeat;
    border: 1px solid #d4d4d4;
  }

  img {
    display: none;
  }
</style>